import CalendarWidget from '../widgets/CalendarWidget';
import ApprovalWidget from '../widgets/ApprovalWidget';
import NoticesWidget from '../widgets/NoticesWidget';
import OrderProgressWidget from '../widgets/OrderProgressWidget';
import { useCompanyStore } from '../../store/companyStore';
import { isGuest } from '../../types/companyRole';
import './Dashboard.css';

function Dashboard() {
  const role = useCompanyStore((s) => s.role);
  const guestMode = isGuest(role);

  return (
    <main className={`ec-dashboard${guestMode ? ' is-guest' : ''}`}>
      <div className="ec-dashboard__intro">
        <div>
          {guestMode ? (
            <>
              <h1>게스트 열람 모드</h1>
              <p>만료일까지 회사 문서를 읽기 전용으로 확인할 수 있습니다. 등록·수정·승인은 불가합니다.</p>
            </>
          ) : (
            <>
              <h1>오늘 현장 한눈에</h1>
              <p>일정 · 결재 · 공지 · 계약 진행을 Linelog 워크스페이스에서 확인합니다.</p>
            </>
          )}
        </div>
      </div>
      {guestMode ? (
        <div className="ec-dashboard__guest">
          <div className="ec-dashboard__guest-card">
            <h2>이용 안내</h2>
            <ul>
              <li>상단 메뉴에서 계약·품질·제품·안전 등 문서를 열어 조회할 수 있습니다.</li>
              <li>모든 작업은 읽기 전용입니다. 저장·승인·삭제는 할 수 없습니다.</li>
              <li>접근 기간이 끝나면 자동으로 열람이 제한됩니다.</li>
            </ul>
          </div>
          <div className="ec-dashboard__guest-side">
            <NoticesWidget />
          </div>
        </div>
      ) : (
        <>
          <div className="ec-dashboard__top">
            <div className="ec-dashboard__calendar">
              <CalendarWidget />
            </div>
            <div className="ec-dashboard__side">
              <ApprovalWidget />
              <NoticesWidget />
            </div>
          </div>
          <div className="ec-dashboard__bottom">
            <OrderProgressWidget />
          </div>
        </>
      )}
    </main>
  );
}

export default Dashboard;
